import { ChartOptions } from "../models/chart.models";

export const DEFAULT_CHART_OPTIONS: ChartOptions = {
  responsive: true,
  scales: {
    x: { beginAtZero: true },
    y: { beginAtZero: true }
  }
}
